/**
 * Pricing-config key mapping — how the two pricing configuration kinds
 * (device-category pricing, billable-feature pricing) address their
 * per-kind redux sub-state and their individual grid rows.
 *
 * A billing admin edits device and feature pricing side by side; each
 * kind is a self-contained working copy keyed by its own name, and each
 * grid row is identified by the thing being priced (a device category or
 * a billable feature). Kept dependency-free so the mapping is unit-
 * testable in isolation.
 *
 * Contains:
 * - PRICING_CONFIG_TYPES — the two config-kind names
 * - pricingConfigKeyFor — config kind -> sub-state map key
 * - PRICING_CONFIG_ROW_KEY / resolvePricingConfigRowKey — row -> its id
 */

export const PRICING_CONFIG_TYPES = ['device', 'feature'];

// Config kind -> the key its sub-state lives under. Non-numeric names
// pass through `String()` (the createSettingsFeature keyFor precedent),
// so 'device' / 'feature' address their sub-state directly.
export const pricingConfigKeyFor = configType => String(configType);

// Row identity differs per pricing config type: device rows key on their
// category id, feature rows key on their feature key.
export const PRICING_CONFIG_ROW_KEY = {
  device: config => config.category?.id,
  feature: config => config.feature?.key,
};

export const resolvePricingConfigRowKey = (configType, config) => PRICING_CONFIG_ROW_KEY[configType](config);
